import { render } from "./SkipperDetail.vue?vue&type=template&id=1fb3e6ab"
import script from "./SkipperDetail.vue?vue&type=script&lang=js"
export * from "./SkipperDetail.vue?vue&type=script&lang=js"
script.render = render

export default script